import config from '.'
import { OrgConfig } from '../types/OrgConfig'

export const defaultConfig = {
  name: 'Zumo',
  theme: {
    palette: {
      primary: { main: '#B246F6' },
      background: { default: '#101011' },
      text: {
        disabled: '#495A67',
        primary: '#BDBDBD',
      },
    },
  },
  links: {
    knowledgeHub: 'https://example.com',
  },
}

const orgConfig: OrgConfig = {
  [config.zumoOrgId]: {
    name: defaultConfig.name,
    theme: defaultConfig.theme,
    links: {
      ...defaultConfig.links,
      deepLinkURI: 'zumo://dlink/financial-promotions-web-app',
    },
  },
  [config.weexOrgId]: {
    name: 'WEEX',
    theme: {
      palette: {
        primary: { main: '#FFEB52' },
        background: { default: '#000000' },
        text: defaultConfig.theme.palette.text,
      },
    },
    links: {
      ...defaultConfig.links,
      knowledgeHub: 'https://weex.zumo.co.uk',
    },
  },
}

export default orgConfig
